import {
  Button,
  Checkbox,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { AddCircle, Edit } from '@material-ui/icons'
import React from 'react'
import { RootStateOrAny, useSelector } from 'react-redux'
import { useDateFormatter } from '../../../hooks/useDateFormatter'
import Loader from '../../Loader/Loader'

interface ProgramTableProps {
  setShowAddProgram: (show: boolean) => void
  toggleSelectedProgram: (program: Program) => void
  setProgramToEdit: (program: Program) => void
  selectedPrograms: Program[]
  setSelectedPrograms: (programs: Program[]) => void
}

interface RowProgramProps {
  program: Program
}

const ProgramTable = ({
  setShowAddProgram,
  toggleSelectedProgram,
  setProgramToEdit,
  selectedPrograms,
  setSelectedPrograms,
}: ProgramTableProps) => {
  const { loading, programs } = useSelector((state: RootStateOrAny) => state.programList)

  const allSelected =
    programs &&
      selectedPrograms.length > 0 &&
      selectedPrograms.length === programs.length
      ? true
      : false

  const indeterminate =
    programs &&
      selectedPrograms.length > 0 &&
      selectedPrograms.length < programs.length
      ? true
      : false

  const handleToggleAllClick = () => {
    if (allSelected) {
      setSelectedPrograms([])
    } else {
      setSelectedPrograms(programs)
    }
  }

  const addProgram = () => {
    setShowAddProgram(true)
  }

  const Row = ({ program }: RowProgramProps) => {
    const isSelected =
      selectedPrograms.filter((x) => x.name === program.name).length > 0

    const editHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation()
      setProgramToEdit(program)
      setShowAddProgram(true)
    }

    return (
      <TableRow>
        <TableCell>
          <Checkbox
            color="primary"
            checked={isSelected}
            onChange={() => toggleSelectedProgram(program)}
          />
          {program.name}
        </TableCell>
        <TableCell>{useDateFormatter(program.updatedAt)}</TableCell>
        <TableCell>
          <div className="actions" style={{ justifyContent: 'flex-end' }}>
            <IconButton onClick={editHandler}>
              <Edit />
            </IconButton>
          </div>
        </TableCell>
      </TableRow>
    )
  }

  return (
    <>
      <div className="flex m-t-30 space-between">
        <h5 className="fs18">Program library</h5>
        <Button variant="contained" color="primary" onClick={addProgram}>
          Add new program
        </Button>
      </div>
      <TableContainer className="scrollable m-b-40 m-t-10">
        <Table stickyHeader aria-label="sticky table">
          {loading ? (
            <TableBody style={{ height: 220, background: 'white' }}>
              <Loader />
            </TableBody>
          ) : programs.length ? (
            <>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Checkbox
                      color="primary"
                      checked={allSelected || indeterminate}
                      indeterminate={indeterminate}
                      onChange={handleToggleAllClick}
                    />
                    Program name
                  </TableCell>
                  <TableCell>Last updated</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {programs.map((program: Program, index: number) => (
                  <Row key={index} program={program} />
                ))}
              </TableBody>
            </>
          ) : (
            <TableBody style={{ height: 203 }}>
              <div onClick={addProgram} className="empty">
                <AddCircle />
                <div className="gray-text">Add a new program</div>
              </div>
            </TableBody>
          )}
        </Table>
      </TableContainer>
    </>
  )
}

export default ProgramTable
